import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CalculatePurchaseService {
  addProduct = new Subject();

  constructor() {}
}
